import axios from "axios";
import Spinner from "helpers/Spinner";
import { baseUrl } from "@ora/recursos/src/helpers/Url";
import ModalCard from "layouts/mainsection/components/ModalCard";
import { nanoid } from "nanoid";
import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import helperStorage from "./helperStorage";
import { import_current_tab, import_set_data, import_success_import } from './store'

const styleFileLoaded = {
  fontSize: '2.5em'
}

class ImportarStep3 extends Component {
  requestInit = null;

  state = {
    nameCurrentFile: 'Buscar',
    activeModalRecurso: false,
    selResource: -1,
    selSubLineaTem: -1,
    listResources: []
  }
  constructor (props) {
    super(props)
    
    this.requestInit = axios.CancelToken.source()


  }
  componentWillUnmount () {
    if (this.requestInit) this.requestInit.cancel()

  }
  componentDidUpdate (props, state) {
    // console.log('update import step 3', this, state, this.state)
    // console.log('update import step 3', props, this.props)
    if (props.importData.typeInformation !== this.props.importData.typeInformation) {
      this.getResourceByTypeIOfformation(this.props.importData.typeInformation)
    }
  }
  getResourceByTypeIOfformation =  (type_information_id) => {
    // console.log('getResourceByTypeIOfformation')
    axios.get(baseUrl(`aro/variable/${type_information_id}/recursos`), { cancelToken: this.requestInit.token }).then(res => {
      // this.props.import_setRecursos(res.data.success ? res.data.data : [])
      this.setState({
        listResources: res.data.success ? res.data.data : []
      })
    })
  }
  componentDidMount () {
    // console.log('mounted step3', this.state, this.props)
    // this.props.import_set_data({resource: 999999})
  }
  disabledProcesar = () => {
    let r = this.props.importData.table.file_structure.filter(item => {
      return item.col_table === '-1'
    });

    return r.length !== this.props.importData.table.file_structure.length;
  }
  OnClick_openModal = () => {
    this.setState({
      activeModalRecurso: true
    })
  }
  onChange = (evt) => {
    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    
    if (evt.target.name === 'selResource') {
      this.setState({
        selResource: evt.target.value
      })
    }
    if (evt.target.name === 'sub_linea_tematica') {
      this.setState({
        selSubLineaTem: evt.target.value
      })
    }
    if (evt.target.name === 'file-doc') {
        //change name curretn file
        let tn = 'Buscar'
        if (evt.target.files[0]) {
            tn = evt.target.files[0].name
        }
        this.setState({
            nameCurrentFile: tn
        })
    }

    this.setState({
      [evt.target.name]: value,
    });
  }
  textprueba = () => {
    // console.log(this.props)
    // console.log(this.state)
    return this.props.currentTab;
  }
  getTypeVarFromStructure = (name) => {
    // max_length
    // type
    let r = this.props.tableStructure.find(item => item.name === name)
    if (r) {
      return (`${r.type}(${r.max_length})`).toUpperCase()
    }
    return 'NOTDEFINED'
  }
  tBodyTableConfig = () => {
    // importData.table.file_structure//file
    // importData.table.structure//table
    return this.props.importData.table.file_structure.map((col, index) => {
      // console.log('props in select update', this.props);
      if (this.props.tableStructure.length > 0) {
        // let ti = this.props.tableStructure.findIndex(tsitem => tsitem === col.col_table)
        let ti = this.props.tableStructure.findIndex(tsitem => tsitem.name === col.col_table)
        // col.col_table = this.props.tableStructure[ ti >= 0 ? ti : 0]
        
          col.col_table =  ti >= 0 ? this.props.tableStructure[ti].name : '-1'
          // col.col_type =  ti >= 0 ? this.props.tableStructure[ti].type : ''
          col.col_type =  this.getTypeVarFromStructure(col.col_table)
          // col.col_type = 'gg'
        
        // this.props.import_set_column({index, col})
      }
      
      return (
        <tr key={index}>
          <td>{col.value}</td>         
          <td>
            <select value={ col.col_table } onChange={ evet => {
              // console.log('change sselect to table', evet.target.value)
              col.col_table = evet.target.value
              col.col_type = this.getTypeVarFromStructure(evet.target.value)
              this.props.import_set_column({index: col.index, col})
            }} name={`columntable-${col.index}`} required="required">
              <option value="-1">- Omitir -</option>
              {this.props.importData.table.structure.map((cT, iT) => <option key={iT} value={cT.name}>{cT.name}</option>)}
            </select>
          </td>
          <td>{col.col_type}</td>
        </tr>
      )
    })
    // return (
    //   <tr></tr>
    // )
  }
  onSubmit_Step3 = (event) => {
    event.preventDefault()
    if (!this.disabledProcesar()) {
      Swal.fire(
        'Importar',
        'Seleccione al menos una columna',
        'error'
      ).then(sr => {
        
      })
      return false
    } 
        // let sendData = this.state
        Spinner.show()
        this.props.import_current_tab(4)
        let sendData = new FormData(document.getElementById('frmImportStep3'));
        
        // sendData.append('tempid', 'IDT' + nanoid(10).toString())
        axios.put(baseUrl('cites/import/file/' + this.props.importData.idFileName), {
          table: this.props.importData.table,
          resource_id: this.props.importData.typeResource
          }, {
          cancelToken: this.requestInit.token,
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            console.log(percentCompleted)
          }
        }).then(res => {
          Spinner.hide()
          if (res.data.success) {
            this.props.import_success_import({
              registros: res.data.totalrows,
              tiempo: res.data.time,
              successRow: res.data.successRows,
              failRow: res.data.errorRows,
              linkFileError: res.data.errorFileName,
              linkSuccess: res.data.localUrl
            })
            // helperStorage.set({
            //   id: res.data.id,
            //   filename: res.data.filename,
            //   step: 1
            // })
          }
        }).catch(err => Spinner.hide())
  }
  CoptionRecursos = () => this.state.listResources.map((item, index) => <option key={index} value={ item.id }>{ item.name}</option>)

  render () {
    return (
      <div id={ this.props.id } className={this.props.className}>
        <form id="frmImportStep3" onSubmit={ this.onSubmit_Step3 }>
        <div className="field is-horizontal">
            <h2 className="title">Asignación de columnas</h2>
          </div>
          
          <div className="field is-horizontal">
            <ul>
              <li>              
                <label className="label">{this.props.importData.typeInformationName}</label>
              </li>
              <li>              
                <label className="label">{this.props.importData.resourceName}</label>
              </li>
           </ul>

          </div>

          <hr />
          <div className="field center">
          <div className="b-table has-pagination">
             <div className="table-wrapper has-mobile-cards">
                 <div className="table-container">
                     <table id="tableconfig" className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                       <thead>
                         <tr>
                           <th>Columnas de Archivo</th>                           
                           <th>Columnas de Destino</th>
                           <th>Tipo Dato</th>
                         </tr>
                       </thead>
                         <tbody>
                           {this.tBodyTableConfig()}
                        </tbody>
                     </table>
                 </div>
             </div>
           
         </div>
          </div>
          <hr />
          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">

                      <div className="control">
                        <button type="submit" disabled={!this.disabledProcesar()} className="button is-primary">
                          <span>Importa Datos</span>
                        </button></div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

            </div>
          
        </form>
     
      </div>
    )
  }
}

const mapStateToProps = (state, props /*, ownProps*/) => {
  console.log('mapStateToProps import2',state)
    return {
      currentTab: state.reducerTab.tab,
      importData: state.reducerData,
      tableStructure: state.reducerData.table.structure,

    }
  }
export default connect(mapStateToProps, {
  import_current_tab, 
  import_set_data,
  import_success_import,
  import_set_column: (data) => {
    return {
      type: 'IMPORT_UPDATE_STRUCTURE',
      payload: data
    }
  }
})(ImportarStep3)